module.exports = __webpack_public_path__ + "media/fonts/Matter-Regular-0b91732e2a5e0dba521839903273a19b.ttf";